export default __webpack_public_path__ + "823fc85c3bbcbc9108117b4c6be4de69.png";